module.exports = __webpack_public_path__ + "img/no_task2088.0345c267.png";